"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var navigation_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/navigation"));
var DEFAULT_NAVIGATION_ITEMS = [
    ['商品', '情報入力'],
    ['お客様', '情報入力'],
    ['お申込み', '完了']
];
var NavigationStore = /** @class */ (function () {
    function NavigationStore(props) {
        var _this = this;
        var _a;
        this.component = navigation_1.default;
        this.navigationItemClassName = function (step) {
            return (0, classnames_1.default)('estimateForm-Navigation_Item', {
                'estimateForm-Navigation_Item-active': _this.step === step,
                'estimateForm-Navigation_Item-withArrow': step < _this.navigationItems.length
            });
        };
        this.step = props.step;
        this.navigationItems = props.navigationItems || DEFAULT_NAVIGATION_ITEMS;
        this.isLpWatchPage = (_a = props.isLpWatchPage) !== null && _a !== void 0 ? _a : false;
    }
    return NavigationStore;
}());
exports.default = NavigationStore;
